import { render, staticRenderFns } from "./HouseTabFiles.vue?vue&type=template&id=fced6836&scoped=true&"
import script from "./HouseTabFiles.vue?vue&type=script&lang=js&"
export * from "./HouseTabFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fced6836",
  null
  
)

export default component.exports